export default function Footer() {
  return (
    <footer className="bg-[#0F1B2D] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="world-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="1" fill="white" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#world-pattern)" />
        </svg>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-20 py-24">
        <div className="flex gap-20 mb-20">
          <div className="w-[30%]">
            <div className="mb-8">
              <img 
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/1638305ab25e301ab9a6bbb2f2a5b416.png" 
                alt="GenieAiX" 
                className="h-12 w-auto mb-6"
              />
              <p className="text-lg text-white/80" style={{ fontFamily: 'Crimson Pro, serif' }}>
                Intelligence, professionally applied.
              </p>
            </div>
            <p className="text-sm text-gray-400 mb-8">
              AI Systems & Automation for Professional Services
            </p>
          </div>

          <div className="flex-1 grid grid-cols-4 gap-12">
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-6">Company</h4>
              <ul className="space-y-4">
                <li><a href="#about" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</a></li>
                <li><a href="#approach" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Our Approach</a></li>
                <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-6">Services</h4>
              <ul className="space-y-4">
                <li><a href="#capabilities" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Capabilities</a></li>
                <li><a href="#industries" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Industries</a></li>
                <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Case Studies</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-6">Resources</h4>
              <ul className="space-y-4">
                <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Documentation</a></li>
                <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Blog</a></li>
                <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Support</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-6">Legal</h4>
              <ul className="space-y-4">
                <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Privacy Policy</a></li>
                <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Terms of Service</a></li>
                <li><a href="#contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Security</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex items-center justify-between">
          <p className="text-sm text-gray-400">
            © 2025 GenieAiX. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/40 transition-colors cursor-pointer">
              <i className="ri-linkedin-line text-white text-lg"></i>
            </a>
            <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/40 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-white text-lg"></i>
            </a>
            <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/40 transition-colors cursor-pointer">
              <i className="ri-facebook-line text-white text-lg"></i>
            </a>
            <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/40 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-white text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
